import Table from "react-bootstrap/Table";

export function RequestedProceduresByProfessionalTable() {
	return (
		<Table className="text-center">
			<thead>
				<tr>
					<th className="text-start">Profissional</th>
					<th>Consultas</th>
					<th>Reavaliações</th>
					<th>Tempo médio de atendimento</th>
				</tr>
			</thead>
			<tbody></tbody>
		</Table>
	);
}
